// src/App.js
import React from 'react';
import Navbar from './components/Navbar';
import Header from './components/Header';
import OurServices from './components/OurServices';
import Trainers from './components/Trainers';
import PricingPlans from './components/PricingPlans';
import TrainingPrograms from './components/TrainingPrograms';
import Aulas from './components/Aulas';
import VideoGallery from './components/VideoGallery';
import Footer from './components/Footer';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  body {
    background-color: #0a0a0a;
    overflow-x: hidden;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <ContainerGeral>
        <Navbar />
        <Header />
        <OurServices />
        <TrainingPrograms />
        <PricingPlans />
        <Trainers />
        <Aulas />
        <VideoGallery />
        <Footer />
      </ContainerGeral>
    </>
  );
}

export default App;

const ContainerGeral = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, #0a0a0a 0%, #0d0d0d 50%, #0a0a0a 100%);
  min-height: 100vh;
  position: relative;
  
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(ellipse at 20% 0%, rgba(229, 168, 0, 0.03) 0%, transparent 50%),
      radial-gradient(ellipse at 80% 100%, rgba(229, 168, 0, 0.02) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
  
  & > * {
    position: relative;
    z-index: 1;
  }
`;
